export default __webpack_public_path__ + "static/media/Gallery-19.54b0916e.jpeg";